import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IEnvironmentConfiguration, IResponse } from "../../Models";
import type { IEnvironmentConfigurationRepository } from "./IEnvironmentConfigurationRepository";

export default class EnvironmentConfigurationRepository implements IEnvironmentConfigurationRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getConfiguration(): Observable<IResponse<IEnvironmentConfiguration>> {
        return this.httpService.get<IEnvironmentConfiguration>("configuration");
    }
}

module("mmRepositories").service("mmEnvironmentConfigurationRepository", EnvironmentConfigurationRepository);
